<script>
	// DRAG AND DROP
	let isOver = false;
	const getDraggedParent = node =>
		(node.dataset.index && node.dataset) || getDraggedParent(node.parentNode);
	const start = ev => {
		ev.stopPropagation();
		if(ev.target.dataset.index === undefined && !ev.target.draggable) {
			console.log('dumbfuck');
		} else {
			ev.dataTransfer.setData("source", getDraggedParent(ev.target).index);
			ev.dataTransfer.setData("real", family);
		}
	};
	const over = ev => {
		ev.preventDefault();
		let dragged = getDraggedParent(ev.target);
		//todo: for <a>, <img>, and other natively draggable things, should not trigger
		if (isOver !== dragged.id) isOver = JSON.parse(dragged.id);
	};
	const leave = ev => {
		let dragged = getDraggedParent(ev.target);
		if (isOver === dragged.id) isOver = false;
	};
	const drop = ev => {
		ev.stopPropagation();
		isOver = false;
		ev.preventDefault();
		if(ev.dataTransfer.getData("real") === family) {
			let dragged = getDraggedParent(ev.target);
			let from = ev.dataTransfer.getData("source");
			let to = dragged.index;
			let temp = list[from];
			list[from] = list[to];
			list[to] = temp;
			list = list;
		} else {
			console.log("you're a fucking idiot")
		}
	};

	// UTILS
	const getKey = item => (key ? item[key] : item);

	// PROPS
	export let list;
	export let key = undefined;
	export let family;
	export let style = undefined;
</script>

<style>
	div {
		transition: border 0.1s linear;
	}
	.over {
		border: 2px dotted rgba(48, 12, 200, 0.2) !important;
	}
</style>

{#each list || [] as item, index (getKey(item))}
	<div
		{style}
		data-index={index}
		data-id={JSON.stringify(getKey(item))}
		draggable="true"
		on:dragstart={start}
		on:dragover={over}
		on:dragend={() => isOver = false}
		on:dragleave={leave}
		on:drop={drop}
		class:over={getKey(item) === isOver}>
		<slot {item} {index}>
			{getKey(item)}
		</slot>
	</div>
{/each}